import { render, staticRenderFns } from "./ReassignFactoryCommand.vue?vue&type=template&id=6989bf9c&scoped=true&"
import script from "./ReassignFactoryCommand.vue?vue&type=script&lang=ts&"
export * from "./ReassignFactoryCommand.vue?vue&type=script&lang=ts&"
import style0 from "./ReassignFactoryCommand.vue?vue&type=style&index=0&id=6989bf9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989bf9c",
  null
  
)

export default component.exports